import { DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { StaffProfession } from '../../models/serializable/staff-profession.js';
import { toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class StaffProfessionsComponent extends Component {
  static readonly TYPE_ID: string = 'a54d7553cae943298116ac252e075454';

  constructor(
    public readonly professions: StaffProfession[],
  ) {
    super();
  }

  get $typeId(): string {
    return StaffProfessionsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): StaffProfessionsComponent {
    return new StaffProfessionsComponent(
        MapUtils.getList<StaffProfession>(
            map,
            'professions',
            (value) => toEnumFromString(value as string, StaffProfession),
        ),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'professions': this.professions,
    };
  }

  clone(): this {
    return new StaffProfessionsComponent(
        this.professions,
    ) as this;
  }

  isSame(other: StaffProfessionsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameList(other.professions, this.professions);
  }
}

export class StaffProfessionsComponentBuilder extends DataModelBuilder<StaffProfessionsComponent> {
  build(context: SerializationContext, map: SerializedData): StaffProfessionsComponent {
    return StaffProfessionsComponent.fromMap(context, map);
  }
}
